﻿import { get } from "svelte/store";
import model from "../stores/modelStore";

import LandingPage from "./LandingPage.svelte"
import PersonalDetails from "./PersonalDetails.svelte"
import GeneralInformation from "./GeneralInformation.svelte"
import FundDetails from "./FundDetails.svelte"
import MedicalDetails from "./MedicalDetails.svelte"
import EducationDetails from "./EducationDetails.svelte"
import Confirmation from "./Confirmation.svelte"
import ThankYou from "./ThankYou.svelte"

let surveyPages = [];
surveyPages.push({
    pageIndex: 0,
    title: "Super & Dis",
    pageTitle: "Super & Dis",
    component: LandingPage,
    routeId: "/check-my-case/super",
    showInTracker: false,
    nextPage: "/check-my-case/super/personal-details",
    nextLabel: "Start the Survey",
});
surveyPages.push({
    pageIndex: 1,
    title: "Personal Details",
    pageTitle: "Super & Dis - Personal Details",
    component: PersonalDetails,
    routeId: "/check-my-case/super/personal-details",
    showInTracker: true,
    previousPage: "/check-my-case/super",
    nextPage: "/check-my-case/super/general-information",
});
surveyPages.push({
    pageIndex: 2,
    title: "General Information",
    pageTitle: "Super & Dis - General Information",
    component: GeneralInformation,
    routeId: "/check-my-case/super/general-information",
    showInTracker: true,
    previousPage: "/check-my-case/super/personal-details",
    nextPage: (model) => !model.GeneralInformationScreenOut ? "/check-my-case/super/fund-details" : "/check-my-case/super/thank-you",
});
surveyPages.push({
    pageIndex: 3,
    title: "Fund Details",
    pageTitle: "Super & Dis - Fund Details",
    component: FundDetails,
    routeId: "/check-my-case/super/fund-details",
    showInTracker: () => get(model).HasSuperFund != "False",
    previousPage: "/check-my-case/super/general-information",
    nextPage: (model) => (!model.GeneralInformationScreenOut && !model.FundDetailsScreenOut) ? "/check-my-case/super/medical-details" : "/check-my-case/super/thank-you",
});
surveyPages.push({
    pageIndex: 4,
    title: "Injury, Illness & Treatment",
    pageTitle: "Super & Dis - Injury, Illness & Treatment",
    component: MedicalDetails,
    routeId: "/check-my-case/super/medical-details",
    showInTracker: (model) => (!model.GeneralInformationScreenOut && !model.FundDetailsScreenOut),
    previousPage: "/check-my-case/super/fund-details",
    nextPage: "/check-my-case/super/education-details",
});
surveyPages.push({
    pageIndex: 5,
    title: "Education, Training & Experience",
    pageTitle: "Super & Dis - Education, Training & Experience",
    component: EducationDetails,
    routeId: "/check-my-case/super/education-details",
    showInTracker: (model) => (!model.GeneralInformationScreenOut && !model.FundDetailsScreenOut),
    previousPage: "/check-my-case/super/medical-details",
    nextPage: "/check-my-case/super/confirmation",
});
surveyPages.push({
    pageIndex: 6,
    title: "Confirmation",
    pageTitle: "Super & Dis - Confirmation",
    component: Confirmation,
    routeId: "/check-my-case/super/confirmation",
    showInTracker: (model) => (!model.GeneralInformationScreenOut && !model.FundDetailsScreenOut),
    previousPage: "/check-my-case/super/education-details",
    nextPage: "/check-my-case/super/thank-you",
    params: {
        isConfirmation: true
    },
});
surveyPages.push({
    pageIndex: 7,
    title: "Thank You",
    pageTitle: "Super & Dis - Thank You",
    component: ThankYou,
    routeId: "/check-my-case/super/thank-you",
    showInTracker: true,
    nextLabel: "Click here to sign Authority",
    nextPage: (model) => (!model.GeneralInformationScreenOut && !model.FundDetailsScreenOut) ? getDocuSignUrl(model) : null,
    endSurvey: true,
});

surveyPages.push({
    pageIndex: 8,
    title: "Review",
    pageTitle: "Super & Dis - Review",
    component: Confirmation,
    routeId: "/Review",
    showInTracker: false,
    params: {
        isConfirmation: false
    },
});

export default surveyPages;

const getDocuSignUrl = (model) => {
    let url = "https://au.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=b907e369-73b2-4f2d-b3c2-f2324abc9194&env=au&acct=4435ed7e-65de-4d1d-a907-b11f469ab88f&v=2";
    let params = `&Client_UserName=${model.Contact.FirstName} ${model.Contact.Surname}&Client_Email=${model.Contact.EmailAddress}&ClientName=${model.Contact.FirstName} ${model.Contact.Surname}&DateOfBirth=${model.Contact.DateOfBirth}&Address=${model.ContactAddress.FormattedAddress}`;

    return `${url}${params}`;
}
